import React from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { classes } from "typestyle";
import ResizeObserver from "resize-observer-polyfill";
import { InformationBlock } from "../../types";
import * as styles from "./styles";
import prettyUrl from "../../helpers/prettyUrl";
import { ReactComponent as ChevronDown } from "../../assets/icons/chevron_down.svg";

interface IProps {
  info: InformationBlock[];
  onSetModalOpen: () => void;
}

const PracticalInformationPreview: React.FC<IProps> = ({ info, onSetModalOpen }) => {
  const [isExpandable, setIsExpandable] = React.useState(false);
  const previewObserver = React.useCallback((node: any) => {
    if (!node) return;
    const resizeObserver = new ResizeObserver(() => {
      setIsExpandable(node.offsetHeight > 350);
    });
    resizeObserver.observe(node);
  }, []);

  const intl = useIntl();

  return (
    <div
      className={classes(styles.organizerInfoBox)}
      style={{ background: "inherit", justifyContent: "space-between", position: "relative" }}
    >
      <div className={classes(isExpandable && styles.preview, styles.practicalInfoButton)}>
        <div className={styles.organizerInfoHeader}>
          <div className={styles.organizerInfoBoxText}>
            <span style={{ textAlign: "left" }}>
              <FormattedMessage
                id={"screens.Event.practicalInfo"}
                defaultMessage="Practical information"
              />
            </span>
          </div>
        </div>
        <div
          className={classes(styles.informationBox)}
          style={{ width: "100%", display: "flex", flexDirection: "column" }}
          ref={previewObserver}
          translate="yes"
        >
          {info.map((i, index) => (
            <div className={styles.infoBoxText} key={index}>
              <span style={{ textAlign: "left" }}>{i.header}</span>
              {i.informationType === "link" ? (
                <a
                  href={"https://" + prettyUrl(i.info)}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ textAlign: "left" }}
                >
                  {prettyUrl(i.info)}
                </a>
              ) : (
                <span
                  style={{ whiteSpace: "break-spaces", textAlign: "left", wordBreak: "break-word" }}
                >
                  {i.info}
                </span>
              )}
            </div>
          ))}
        </div>
      </div>
      {isExpandable && (
        <button
          className={styles.expandButton}
          onClick={() => onSetModalOpen()}
          aria-label={intl.formatMessage({
            id: "screens.Event.practicalInfo.showMoreButton",
            defaultMessage: "Open full information panel",
          })}
        >
          <ChevronDown height={18} width={18} />
        </button>
      )}
    </div>
  );
};

export default PracticalInformationPreview;
